import { FieldErrors } from "react-hook-form"

export function extractErrorMessages(errors: FieldErrors): string[] {
  const messages: string[] = []

  // level 1 (field biasa)
  Object.values(errors).forEach((err: any) => {
    if (!err) return

    if (err.message) {
      messages.push(err.message)
    }

    // kalau array (contoh: invoice_detail)
    if (Array.isArray(err)) {
      err.forEach((item) => {
        if (!item) return

        Object.values(item).forEach((nested: any) => {
          if (nested?.message) {
            messages.push(nested.message)
          }
        })
      })
    }

    // kalau nested object 1 level
    if (typeof err === "object" && !Array.isArray(err)) {
      Object.values(err).forEach((nested: any) => {
        if (nested?.message) {
          messages.push(nested.message)
        }
      })
    }
  })

  return messages
}
